import crud from "../../../../stores/crud";

const state = {
	...crud.state,
	routes: {
		index: "leads",
		show: "leads/:lead",
	},
};

export default {
	namespaced: true,
	state,
	actions: {
		...crud.actions,
	},
	mutations: {
		...crud.mutations,
		UPDATE_ITEM(state, payload) {
			crud.mutations.UPDATE_ITEM(state, payload);
			this.commit("clients/LEAD_UPDATED", payload);
		},
	},
	getters: {
		...crud.getters,
	},
};
